'use strict';

const alertMessage = require('../utils/alertMessage');
const eventRegistrationHelper = require('../utils/eventRegistrationHelper');
var debounce = require('lodash/debounce');
const { hideForm, showForm, goBack, updateStage, registrationCompleted, renderRenderedTemplate, showComponent, hideComponent, backToRegistrationForm, addFormValidation, removeFormValidation, toggleInviteFriendFields, touchForm, touchFilledForm, clearFormErrors, clearParams, preFillSelects, getInvitedUrl, openInviteFriendEvent, validateEmail } = require('./eventHelper');
const { SELECTORS, STAGES } = require('./variables');

var currentForm = SELECTORS.checkUserForm;
var eventCompleted = false;

eventRegistrationHelper.init();

/* Remove eventStage on loading page */
clearParams();

/* Send login event for Loyalty App */
$(SELECTORS.openLoginAppEvent).on('click', (e) => {
    if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler){
        window.flutter_inappwebview.callHandler('open_login', {redirectUrl: window.location.href});
    }
});

/* Remove max age for minor date picker */
const today = new Date();
let currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
const maxDate = currentDate.toISOString().split('T')[0];
setTimeout(() => { $(SELECTORS.eventMinorRegistrationForm).find('input[name="dwfrm_fullEvent_fullEvent_minorBirthday"]').attr('max', maxDate) }, 1)

/* Show runtime errors */
$('body').on('blur change', `${SELECTORS.fullEventModal} ${SELECTORS.formControl}`, function() {
    var $this = this;
	var form = $($this).closest('form');
    let $errorMsg = $($this).closest('.form-group').find('.invalid-feedback');
    let $fieldName = $($this).closest('.form-group').find('.cc-form__label');
    if($this && $errorMsg && $errorMsg.hasClass('cc-message--visible') && form.hasClass('js-event-registration-form')){
        let erroreMessage = $errorMsg.text();
        if(erroreMessage.includes('obbligatorio')){
            alertMessage(`Campo ${$fieldName.text()} obbligatorio.`, 'cc-alert--danger')
        } else{
            alertMessage(erroreMessage, 'cc-alert--danger');
        }
    }

    toggleInviteFriendFields();
});

/* Back button to return to check user form && clear form from BE controller */
$(SELECTORS.backButton).on('click', async function (e) {
    goBack();
});

/* Show "invite a friend" fields */
toggleInviteFriendFields();
$(SELECTORS.inviteFriendCheckbox).on('change', async function () {
    toggleInviteFriendFields();
    touchForm(SELECTORS.inviteFriendFields);
    clearFormErrors(SELECTORS.inviteFriendFields);
    touchFilledForm(currentForm);
});

/* Fetch invited friend from ESB and compile form */
var debounceValidation = debounce(validateEmail, 500);
if ($(SELECTORS.inviteFriendInput).length !== 0) {
    $(SELECTORS.inviteFriendInput).on('input', () => {
        const value = $(SELECTORS.inviteFriendInput).val();
        const action = $(SELECTORS.inviteFriendInput).data('action');

        const callback = (response) => {
            if (response.success && response.exist && response.currentCustomer) {
                $(SELECTORS.inviteFriendFname).val(response.currentCustomer.firstName).trigger('change').trigger('focus').addClass('cc-form__input--readonly').prop('readonly', true).attr('aria-readonly', 'true')  ;
                $(SELECTORS.inviteFriendLname).val(response.currentCustomer.lastName).trigger('change').trigger('focus').addClass('cc-form__input--readonly').prop('readonly', true).attr('aria-readonly', 'true')  ;
                $(SELECTORS.inviteFriendInput).trigger('focus');
            } else {
                $(SELECTORS.inviteFriendFname).removeClass('cc-form__input--readonly').prop('readonly', false).removeAttr('aria-readonly');
                $(SELECTORS.inviteFriendLname).removeClass('cc-form__input--readonly').prop('readonly', false).removeAttr('aria-readonly');
            }
        };

        if (value.length > 0) {
            debounceValidation(value, action, callback);
        }
    });
}

/* Get and set submitUrl from clicked button */
$(SELECTORS.eventSelected).on('click', function (e) {
    const el = e.currentTarget;
    const eventId = $(el).data('event-id');
    const eventParentId = $(el).data('event-parent-id');
    const submitUrl = $(el).data('event-url');
    const isForMinors = $(`.js-event-${eventId}`).data('is-for-minors');
    $(SELECTORS.checkUserForm).attr('action', submitUrl);
    $(SELECTORS.checkUserForm).attr('data-event-id', eventId);
    $(SELECTORS.dataset).attr('data-event-id', eventId);
    $(SELECTORS.dataset).attr('data-event-parent-id', eventParentId);
    if(!isForMinors){
        hideComponent(SELECTORS.minorCheckbox);
    } else{
        showComponent(SELECTORS.minorCheckbox);
    }
    updateStage(STAGES.checkUser);
    removeFormValidation(SELECTORS.eventAdultRegistrationForm);
    removeFormValidation(SELECTORS.eventMinorRegistrationForm);
    currentForm = SELECTORS.checkUserForm;
    touchForm(currentForm);
    clearFormErrors(currentForm);
});

/* Event Registration Check user */
$(SELECTORS.checkUserForm).on('submit', function (e) {
    e.preventDefault();
    $.spinner().start();
    const $form = $(this);
    let formData = $form.serialize();

    $.ajax({
        url: $form.attr('action'),
        method: 'POST',
        data: formData,
        success: function (data) { 
            if (data.error) {
                $.spinner().stop();
                alertMessage(data.errorMessage, 'cc-alert--danger');
                return;
            }

            if(data.isMinor && data.renderedTemplate){
                renderRenderedTemplate(data.renderedTemplate, SELECTORS.existingMinorRegistrations);
            }
            renderRenderedTemplate(data.eventDetailsTemplate, SELECTORS.eventDetails);
            addFormValidation(data.registrationFormToShow);
            removeFormValidation(data.registrationFormToRemove);
            preFillSelects(data.registrationFormToShow);
            hideForm(SELECTORS.checkUserForm);
            showForm(data.registrationFormToShow, data.submitUrl, data.form.fullEvent);
            eventRegistrationHelper.syncAddressVisibility(data.registrationFormToShow);
            updateStage(data.registrationFormToShow === SELECTORS.eventAdultRegistrationForm ? STAGES.adultRegistration : STAGES.minorRegistration);

            currentForm = data.registrationFormToShow;
            touchForm(currentForm);
            clearFormErrors(currentForm);

            /* Handle invite friend form - Show only if pro event */
            let isForPro = $(`.js-event-${data.eventCode}`).data('is-for-pro');
            let isInvitedFriend = $(`.js-event-${data.eventCode}`).data('is-invited');
            let canInviteFriend = $(`.js-event-${data.eventCode}`).data('can-invite-friend');
            
            if(isForPro){
                $(currentForm).find('.js-invite-friend-wrapper').show();
            } else{
                $(currentForm).find('.js-invite-friend-wrapper').hide();
            }
            if(isInvitedFriend){
                $(currentForm).find('.js-invite-friend-wrapper').hide();
            }
            if(isForPro && canInviteFriend){
                $(currentForm).find('.js-invite-friend-wrapper').show();
            }

            $.spinner().stop();

        },
        error: function (err) {
            alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            $.spinner().stop();
        }
    });
});

/* Event Registration Handler */
$(SELECTORS.eventRegistrationForm).on('submit', function (e) {
    e.preventDefault();
    $.spinner().start();
    const $form = $(this);
    let formData = $form.serialize();

    $.ajax({
        url: $form.attr('action'),
        method: 'POST',
        data: formData,
        success: function (data) {
            if (data.error) {
                alertMessage(data.errorMessage, 'cc-alert--danger');
                $.spinner().stop();
                return;
            }
            handleDocusign(data, currentForm);
            hideForm(SELECTORS.eventRegistrationForm);
            $(SELECTORS.eventDetails).empty();

            $.spinner().stop();
        },
        error: function (err) {
            alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            $.spinner().stop();
        }
    });
});

/* Reset flow when closing the modal */
$(SELECTORS.fullEventModal).on('hide.bs.modal', function (e) {
    const params = new URLSearchParams(window.location.search);
    const eventStage = params.get('eventStage');
    if((eventStage && eventStage == STAGES.completed) || eventCompleted){
        $.spinner().start();
        window.location.reload();
    } else{
        goBack(true);
    }
});

/* If invited friend, open automatically the event modal */
openInviteFriendEvent();

async function handleDocusign(data, currentForm) {
    let signingUrl = data.embeddedRecipientUrl;
    let clientId = data.integrationKey;
    const proceedText = $('.js-docusign-container').data('proceed-text');

    if (!signingUrl) { throw new Error() }

    const signingConfiguration = {
        url: signingUrl,
        displayFormat: 'focused',
        style: {
            branding: {
                primaryButton: {
                    /** Background color of primary button */
                    backgroundColor: "black",
                    /** Text color of primary button */
                    color: "white",
                }
            },
            signingNavigationButton: {
                finishText: proceedText, // default is Submit
                // 'bottom-left'|'bottom-center'|'bottom-right',  default: bottom-right
                position: "bottom-center"
            }
        }
    }

    try {
        const docusign = await window.DocuSign.loadDocuSign(clientId);

        const signing = docusign.signing(signingConfiguration);

        signing.on('sessionEnd', (event) => {

            $.spinner().start();

            if (event.sessionEndType == 'session_timeout') {
                if (data.expiredSessionUrl) {
                    goBack();
                    $.spinner().stop();
                }
                return;
            }
            if (event.sessionEndType == 'signing_complete') {
                if (data.redirectUrl) {
                    handleResponse(data.redirectUrl, currentForm, data);
                }
                return;
            }
            if (event.sessionEndType == 'canceled') {
                if (!data.error) {
                    backToRegistrationForm(data);
                    $.spinner().stop();
                }
                return;
            }
            if (event.sessionEndType == 'decline') {
                if (!data.error) {
                    backToRegistrationForm(data);
                    $.spinner().stop();
                }
                return;
            }

            /* General Error */
            if (!data.error) {
                backToRegistrationForm(data);
                $.spinner().stop();
            }
        });

        // Open the signing ceremony
        $(`.js-event-form-container`).hide();
        $(`.js-docusign-container`).show();
        showComponent(`#signing-ceremony`);
        signing.mount(`#signing-ceremony`);
        updateStage(STAGES.docuSign);
    } catch (error) {
        // Any configuration or API limits will be caught here
        console.error("### Error calling docusign.js");
        console.error(error);
    }
}

function handleResponse(redirectUrl, currentForm, data) {
    var $form = $(currentForm);
    let formData = $form.serialize();

    /* If invite friend, send invite url to BE */
    let invitedUrl = getInvitedUrl($form);
    if(invitedUrl){
        let eventCode = data && data.eventCode ? data.eventCode : false;
        var data = $form.serializeArray();
        data.push({
            name: 'invitedUrl',
            value: invitedUrl
        });
        if(eventCode){
            let eventDataset = $(`.js-event-${eventCode}`);
            if(eventDataset && eventDataset.data('is-invited-not-from-link')){
                data = $form.serializeArray();
                data.push({
                    name: 'isInvited',
                    value: eventDataset.data('is-invited-not-from-link')
                });
            }
        }
        formData = $.param(data);
    }

    /* If registration of invited friend */
    if(data && data.eventCode){
        let eventDataset = $(`.js-event-${data.eventCode}`);
        if(eventDataset && eventDataset.data('is-invited') && eventDataset.data('invited-by')){
            var data = $form.serializeArray();
            data.push({
                name: 'isInvited',
                value: eventDataset.data('is-invited')
            });
            data.push({
                name: 'invitedBy',
                value: eventDataset.data('invited-by')
            });
            formData = $.param(data);
        }
        if(eventDataset && eventDataset.data('is-invited-not-from-link')){
            var data = $form.serializeArray();
            data.push({
                name: 'isInvited',
                value: eventDataset.data('is-invited-not-from-link')
            });
            formData = $.param(data);
        }
    }
    try {
        createCampaignMember(formData, redirectUrl);
    } catch (error) {
        if ($.spinner()) $.spinner().stop();
        console.error('Catch error: ', error);
    }
}

function createCampaignMember(formData, redirectUrl) {
    $.ajax({
        url: redirectUrl,
        method: 'POST',
        data: formData,
        success: function (data) {
            if (data.error) {
                $.spinner().stop();
                alertMessage(data.errorMessage, 'cc-alert--danger');
                return;
            }

            handleRegistrationCompleted(data.redirectUrl);
        },
        error: function (err) {
            alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            $.spinner().stop();
        }
    });
}

function handleRegistrationCompleted(redirectUrl){
    $.ajax({
        url: redirectUrl,
        success: function (data) {
            if (data.error) {
                $.spinner().stop();
                alertMessage(data.errorMessage, 'cc-alert--danger');
                return;
            }

            registrationCompleted(data.renderedTemplate);
            // removeInvitefriendParams();
            eventCompleted = true;
            $.spinner().stop();
        },
        error: function (err) {
            alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            $.spinner().stop();
        }
    });
}
